import { FeatureFlagChannel } from '@tableau/microview-communication-service/lib/src/channelDefinitions/FeatureFlagChannelDefinitions';

export enum FeatureFlag {
    searchEPT = 'searchEPT',
    searchQuickLinks = 'searchQuickLinks',
    searchV2 = 'searchV2',
    searchProductMetrics = 'searchProductMetrics',
    metricsSpaceEnabled = 'metricsSpaceEnabled',
    collectionsSiteSetting = 'collectionsSiteSetting',
    questronEnabled = 'questronEnabled',
    smarterSearchEnabled = 'smarterSearchEnabled'
}

export class FeatureFlagService {
    private featureFlagChannel = new FeatureFlagChannel();
    public static instance = new FeatureFlagService();

    public getValue(featureFlag: FeatureFlag): boolean {
        return this.featureFlagChannel.call({ featureFlag: featureFlag }).data?.featureFlagState || false;
    }
}
